import { render, staticRenderFns } from "./CallSummary.vue?vue&type=template&id=5fb67314&scoped=true"
import script from "./CallSummary.vue?vue&type=script&lang=js"
export * from "./CallSummary.vue?vue&type=script&lang=js"
import style0 from "./CallSummary.vue?vue&type=style&index=0&id=5fb67314&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb67314",
  null
  
)

export default component.exports